import React, { useState } from 'react'
import BasicTabs from '../../../components/tabs/basic-tabs/basic-tabs.component'
import { Tabs } from '../driver.constant'
import { Grid2 } from '@mui/material'
import TabPanel from '../../../components/tabs/tab-panel/tab-panel.component'
import DriverLicence from './driver-licence/driver-licence.component'
import DriverTracking from './driver-tracking/driver-tracking.component'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store'
import DriverNotSelected from '../driver-not-selected/driver-not-selected.component'
import DriverNew from '../driver-new/driver-new.component'

const DriverDetails = () => {
  const [tabsValue, setTabsValue] = useState(0)

  const selectedDriver = useSelector(
    (state: RootState) => state.drivers.selectedDriver
  )

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabsValue(newValue)
  }

  if (!selectedDriver?.id) {
    return <DriverNotSelected />
  }

  const isNewDriver =
    !selectedDriver.driverAppStatus ||
    selectedDriver.driverAppStatus.toUpperCase() === 'NEW'

  const tabsToUse = isNewDriver
    ? [{ ...Tabs[0], label: 'Driver' }, ...Tabs.slice(1)]
    : Tabs

  return (
    <div>
      <div>
        <BasicTabs tabs={tabsToUse} value={tabsValue} handleChange={handleChange}>
          <Grid2 container>
            <Grid2 size={{ xs: 6, sm: 7, md: 8 }} p={2}>
              <TabPanel value={tabsValue} index={0}>
                {isNewDriver && <DriverNew />}
                {!isNewDriver && <DriverLicence driver={selectedDriver} />}
              </TabPanel>
            </Grid2>

            <Grid2
              size={{ xs: 6, sm: 5, md: 4 }}
              sx={{
                bgcolor: 'secondary.light',
                overflow: 'hidden',
                minHeight: '100vh',
              }}
            >
              <DriverTracking />
            </Grid2>
          </Grid2>
        </BasicTabs>
      </div>
    </div>
  )
}

export default DriverDetails
